// RechargeAccountDialog.Style.js - MUI 5 compatible styles

import { phoneInputCss } from '../../../css/phoneInput';

const rechargeAccountDialogStyles = {
  container: (theme) => ({
    marginTop: theme.spacing(6),
    minHeight: 'calc(100vh - 600px)',
    display: 'flex',
    textAlign: 'center',
    '& a:hover': {
      textDecoration: 'none'
    }
  }),
  h1: (theme) => ({
    ...theme.typography.h1,
    color: theme.palette.custom.neoViolet.main,
    marginTop: theme.spacing(6),
    fontSize: '3.3rem',
    fontWeight: 800,
    lineHeight: '1.1',
    marginBottom: theme.spacing(2),
    // letterSpacing: '0.6px',
    fontFamily: ['Product Sans', 'sans-serif'].join(','),
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('md')]: {
      fontSize: '3rem'
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.6rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '2.3rem',
      lineHeight: '1.1',
      textAlign: 'center'
    }
  }),
  h2: (theme) => ({
    ...theme.typography.h2,
    fontSize: '2.4rem',
    fontWeight: 700,
    lineHeight: '1.2',
    color: theme.palette.custom.neoViolet.main,
    marginBottom: theme.spacing(1),
    fontFamily: ['Product Sans', 'sans-serif'].join(','),
    whiteSpace: 'pre-wrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.2rem',
      lineHeight:'1.3'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '2rem',
      lineHeight: '1.3',
      textAlign: 'center'
    }
  }),
  h3: (theme) => ({
    ...theme.typography.h3,
    fontSize: '1.6rem',
    fontWeight: 700,
    fontFamily: ['Product Sans', 'sans-serif'].join(','),
    whiteSpace: 'pre-wrap',
    lineHeight: '1.4',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.6rem',
      lineHeight: '1.3',
      textAlign: 'center'
    }
  }),
  h5: (theme) => ({
    fontWeight: 600,
    fontSize: '1.1rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1)
  }),
  smallh5: (theme) => ({
    fontWeight: 400,
    fontSize: '1.1rem',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  }),
  yearlyToggle: (theme) => ({
    margin: '0 auto',
    marginBottom: theme.spacing(2),
    '& label': {
      flexWrap: 'nowrap'
    }
  }),
  marginTop: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  marginBottom: (theme) => ({
    marginBottom: theme.spacing(4)
  }),
  testimonial2: (theme) => ({
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(3)
  }),
  smallPaper: (theme) => ({
    minHeight: '0px !important',
    paddingTop: '0px !important',
    paddingBottom: '0px !important'
  }),
  rechargesCtr: (theme) => ({
    width: '100%',
    flexDirection: 'column',
    margin: '0 auto',
    '& a:hover': {
      textDecoration: 'none'
    }
  }),
  gridPaper: (theme) => ({
    ...theme.squareplan.window.width,
    borderRadius: 0,
    margin: '0 auto',
    marginBottom: theme.spacing(3),
    minHeight: 200,
    paddingBottom: 0,
    '& h2': {
      fontSize: '2rem',
      color: theme.palette.primary.main,
      paddingBottom: 0
    }
  }),
  hiddenSpace: (theme) => ({
    color: '#fff !important',
    pointerEvents: 'none'
  }),
  featuresList: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('xs')]: {
      paddingBottom: theme.spacing(2),
      backgroundColor: 'transparent',
      backgroundImage:
        'linear-gradient(180deg, rgba(234,234,234,0.23) 0%, #ffffff 100%)'
    }
  }),
  featureHeader: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 200,
    // borderBottom: `1px solid ${theme.palette.border.color}`,
    borderRight: `1px solid ${theme.palette.border.color}`,
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  gridCell: (theme) => ({
    display: 'flex',
    maxHeight: 50,
    minHeight: 50,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
    borderRight: `1px solid ${theme.palette.border.color}`,
    // borderBottom: `1px solid ${theme.palette.border.color}`,
    '&.bottom': {
      borderBottom: 0
    },
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      margin: `${theme.spacing(1)}px 0px`,
      maxHeight: 'auto',
      minHeight: 'auto'
    }
  }),
  emphasis: (theme) => ({
    fontSize: '1rem !important',
    fontWeight: 700,
    paddingTop: theme.spacing(4.5)
  }),
  emphasisDescr: (theme) => ({
    fontWeight: 600,
    fontSize: '16px !important',
    paddingTop: `${theme.spacing(4.5)} !important`
  }),
  featureDesc: (theme) => ({
    padding: `0px ${theme.spacing(2)}`,
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    fontSize: '0.9rem',
    textAlign: 'left',
    justifyContent: 'left',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      justifyContent: 'center',
      marginTop: theme.spacing(2.5),
      fontSize: theme.spacing(3.25),
      paddingTop: 0
    }
  }),
  featureItem: (theme) => ({
    fontSize: '0.9rem',
    textAlign: 'center',
    '& pre': theme.typography.pre
  }),
  checkIcon: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: '1.1rem'
  }),
  buy: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  topBuy: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(0),
    borderRadius: theme.spacing(3),
    maxWidth: '90%',
    fontSize: '0.8rem',
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(1.75)
    },
    [theme.breakpoints.only('sm')]: {
      marginTop: theme.spacing(1.25),
      fontSize: '0.8rem'
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1)
    }
  }),
  mobileOnlyPricingGridHOCtr: (theme) => ({
    width: '100%',
    margin: 0,
    display: 'flex',
    flexDirection: 'column'
  }),
  mobileOnlyPricingGridContainer: (theme) => ({
    ...theme.squareplan.window.width,
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column'
    }
  }),
  tableCaptionCtr: (theme) => ({
    marginBottom: theme.spacing(6)
  }),
  mobileOnlyGridCell: (theme) => ({
    display: 'flex',
    padding: `${theme.spacing(1.5)} ${theme.spacing(3)}`,
    justifyContent: 'flex-start',
    alignItems: 'center',
    '&.bottom': {
      borderBottom: 0,
      fontSize: theme.spacing(4)
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      justifyContent: 'left',
      textAlign: 'left',
      borderBottom: 0,
      borderRight: 0,
      margin: `${theme.spacing(1)} 0px`,
      maxHeight: 'auto',
      minHeight: 'auto',
      fontSize: theme.spacing(2.5)
    }
  }),
  mobileOnlyFeature: (theme) => ({
    marginLeft: theme.spacing(3),
    fontSize: '1rem'
  }),
  mobileOnlyFeatureHeader: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing(0),
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  bottomText: (theme) => ({
    textAlign: 'center',
    '& p': {
      margin: 0,
      lineHeight:' 1.5'
    },
    marginBottom: theme.spacing(4)
  }),
  topUpTable: (theme) => ({
    width: '50%'
  }),
  planTitle: (theme) => ({
    fontSize: '1.5rem !important',
    fontWeight: 700,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main
  }),
  ctaCaption: (theme) => ({
    color: '#7A7A7A',
    fontSize: '0.9rem',
    [theme.breakpoints.up('sm')]: {
      marginTop: theme.spacing(0.5)
    }
  }),
  planPrice: (theme) => ({
    fontSize: '1.2rem',
    fontWeight: 600
  }),
  striked: (theme) => ({
    textDecoration: 'line-through',
    fontSize: '0.9rem',
    fontWeight: 400,
    marginTop: 0,
    color: theme.palette.text.disabled
  }),
  rechargesTitleCtr: (theme) => ({
    textAlign: 'center',
    marginBottom: theme.spacing(4)
  }),
  creditItemCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    marginBottom: -theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      marginBottom: -theme.spacing(2)
    }
  }),
  itemBodyLeft: (theme) => ({
    flexGrow: 1
  }),
  itemBodyRight: (theme) => ({}),
  itemBodyCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  itemFooter: (theme) => ({
    flexGrow: 1,
    borderBottom: '3px dashed hsl(0,0%,50%)'
  }),
  topupCredits: (theme) => ({
    fontSize: '1.5rem',
    paddingBottom: theme.spacing(0),
    fontWeight: 600
  }),
  topupCaption: (theme) => ({
    fontSize: '0.9rem',
    fontWeight: 500,
    color: 'hsl(0,0%,50%)',
    paddingBottom: theme.spacing(0)
  }),
  topupPrice: (theme) => ({
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    borderRadius: 24,
    position: 'relative',
    top: '8px',
    padding: '2px 16px',
    fontWeight: 600,
    fontSize: '1rem'
  }),
  planPricePAYG: (theme) => ({
    marginTop: 4,
    fontWeight: 600,
    fontSize: '1rem'
  }),
  newCenteredSectionCtr: (theme) => ({
    margin: '0 auto',
    textAlign: 'center'
  }),
  topMarginSpacing2: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  topMarginSpacing4: (theme) => ({
    marginTop: theme.spacing(4)
  }),
  topMarginSpacing6: (theme) => ({
    marginTop: theme.spacing(6)
  }),
  bottomMarginSpacing2: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  topupSignupBtn: (theme) => ({
    margin: '0 auto',
    borderRadius: theme.spacing(3),
    '& *': {
      fontSize: '1rem'
    }
  }),
  smallBody1: (theme) => ({
    fontSize: '0.9rem'
  }),
  // ContentRenderPlanDesc specific styles
  desktopPlanContainer: (theme) => ({
    width: 'auto'
  }),
  leftColItem: (theme) => ({
    width: 150
  }),
  planColItem: (theme) => ({
    width: 150
  }),
  upgradeFeatureHeader: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 120,
    borderRight: `1px solid ${theme.palette.border.color}`,
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  upgradeFeatureHeaderRight: (theme) => ({
    paddingTop: theme.spacing(4),
    width: '100%',
    height: 120,
    [theme.breakpoints.down('xs')]: {
      borderBottom: 0,
      borderRight: 0,
      height: 'auto'
    }
  }),
  upgradeFeatureItem: (theme) => ({
    fontSize: '0.9rem',
    textAlign: 'center',
    borderRight: 0,
    '& pre': theme.typography.pre
  }),
  clickable: (theme) => ({
    cursor: 'pointer'
  }),

  // dialog styles 
  dialogCtr: (theme) => ({
    maxWidth: '90vw',
    width: 'auto',
    textAlign: 'center'
  }),
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    margin: theme.spacing(1)
  }),
  dialogHeader: (theme) => ({
    margin: theme.spacing(1)
  }),
  grow: (theme) => ({
    flexGrow: 1
  }),
  itemHeader: (theme) => ({
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600
  }),
  itemList: (theme) => ({
    '& p': {
      fontSize: '1rem',
      color: 'hsl(0,0%,80%)'
    }
  }),
  itemRow: (theme) => ({
    display: 'flex'
  }),
  itemDesc: (theme) => ({
    fontSize: '1rem',
    flexGrow: 1
  }),
  itemPrice: (theme) => ({
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
    fontWeight: 600
  }),
  captionText: (theme) => ({
    fontSize: '1rem',
    color: 'hsl(0,0%,50%)'
  }),
  ccCaptionText: (theme) => ({
    marginTop: theme.spacing(2),
    fontSize: '1rem',
    color: 'hsl(0,0%,50%)'
  }),
  checkoutContentHeader: (theme) => ({
    marginBottom: theme.spacing(2)
  }),
  checkoutColCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column'
  }),
  checkoutLineCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row'
  }),
  reviewSectionCtr: (theme) => ({
    minWidth: 300,
    maxWidth: 400,
    textAlign: 'left',
    // marginLeft: theme.spacing(3),
    '& p': {
      // marginBottom: theme.spacing(1),
      fontSize: '1rem',
      justifyContent: 'left',
      alignItems: 'center',
      display: 'flex'
    },
    '& p.MuiTypography-colorTextSecondary': {
      fontSize: '0.8125rem'
    },
    '& > div > p.price': {
      fontWeight: 700,
      marginTop: theme.spacing(1.5)
    },
    '& b': {
      color: theme.palette.primary.main
    }
  }),
  spaceTop: (theme) => ({
    marginTop: theme.spacing(2)
  }),
  pmRadioGroup: (theme) => ({}),
  pmListItem: (theme) => ({
    height: 65,
    cursor: 'pointer',
    border: '1px solid #CCC',
    '&:last-child': {
      marginBottom: theme.spacing(1)
    }
  }),
  pmFormCtr: (theme) => ({
    width: '100%',
    marginBottom: theme.spacing(3)
  }),
  reviewItemCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }),
  reviewItem: (theme) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    cursor: 'default'
  }),
  
  // Additional styles that might be referenced from combineStyles
  contentCtr: (theme) => ({
    flexGrow: 1,
    marginTop: theme.spacing(2),
    textAlign: 'center',
    maxWidth: 700,
    width: 'auto',
    margin: '0 auto',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '95vw',
      marginTop: theme.spacing(2),
      padding: `${theme.spacing(2)}px 0px`
    }
  }),
  formLabel: (theme) => ({
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
    marginBottom: -theme.spacing(0.5)
  }),
  errorLabel: (theme) => ({
    marginLeft: theme.spacing(1),
    color: '#f44336 !important'
  }),
  checkoutInputForm: (theme) => ({
    '& input': {
      padding: '18.5px 14px',
      fontSize: '1em'
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: 'black'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      opacity: 0.75
    }
  }),
  newInputForm: (theme) => ({
    // for older references to classes.newInputForm
  }),
  newFormElt: (theme) => ({
    // for older references to classes.newFormElt
  }),
  defaultChip: (theme) => ({
    // for older references to classes.defaultChip
  }),
  capitalize: (theme) => ({
    textTransform: 'capitalize'
  })
};

export default rechargeAccountDialogStyles;
